import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddFsm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			stroke: "#4A5666",
			transform: "translate(-.536 6.495)",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 5.851,
					cy: 4.611,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					rx: 3.461,
					ry: 2.396
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 18.638,
					cy: 5.436,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					rx: 3.461,
					ry: 2.396
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 10.944,
					cy: 13.025,
					strokeLinecap: "round",
					strokeLinejoin: "round",
					rx: 3.461,
					ry: 2.396
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4A5666",
					strokeWidth: .5,
					d: "m15.258 3.222-2.632-.066 1.105-2.08z"
				}),
				/* @__PURE__ */ _jsx("path", { d: "M8.374 2.753Q11 1.077 13.583 2.286" }),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4A5666",
					strokeWidth: .5,
					d: "m6.66 13.156-2.505.818.612-2.652z"
				}),
				/* @__PURE__ */ _jsx("path", { d: "M3.08 6.389c-1.232.717-3.38 5.379 1.68 6.328" }),
				/* @__PURE__ */ _jsx("path", {
					fill: "#4A5666",
					strokeWidth: .5,
					d: "m19.204 8.728 1.05 1.976-2.604-.366z"
				}),
				/* @__PURE__ */ _jsx("path", { d: "M14.404 13.622c3.246.416 4.568-2.23 4.632-3.7" })
			]
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#4A5666",
			fillRule: "nonzero",
			d: "M18.608.5v2.75h2.75v1.5h-2.75V7.5h-1.5V4.75h-2.75v-1.5h2.75V.5z"
		})]
	})
});
export default SvgAddFsm;
